define('shared/initializer/form/newHouseAdapters/mixins/OffersInfoStorable',[
    'shared/lib/RSVP',
    'shared/remote/offer/get',
    'shared/util/state',
    'shared/util/state/adapters/offers',
    'shared/util/state/adapters/order',
    'shared/initializer/form/constants'
], 
function(
    RSVP,
    getOffer,
    state,
    offersAdapter,
    orderAdapter,
    constants
) {

    function Ctor() {

    }

    Ctor.prototype.doBeforeRedirect = function(data) {
        if (!data || !data.Order_id) {
            return RSVP.resolve(data);
        }

        return RSVP.resolve()
            .then(function(){
                return RSVP.all([state.adapters.add(offersAdapter),state.adapters.add(orderAdapter)]);
            })
            .then(function(){
                return state.retrieve(constants.State.OrderOfferId);
            })
            .then(function(offerIds){
                var offers = Array.isArray(offerIds)?offerIds:[offerIds];
                var promises = [];
                
                for(var i = 0; i < offers.length;i++) {
                    promises.push(
                        getOffer({
                            id: offers[i]
                        })
                    );
                }

                return RSVP.all(promises)
                    .then(function(offers){
                        var promises = [];

                        for(var key in offers) {
                            if (!offers.hasOwnProperty(key)) {
                                return;
                            }
                            promises.push(state.push('offers.' +  key, offers[key]));
                        }
                        
                        return RSVP.all(promises);
                    })
                    .then(function(){
                        return data;
                    });
            });
    };

    return Ctor;
});
